import { z } from 'zod';

/** Форма названия и описания схемы — те же пределы, что у API (diagram-policy.ts). */
export const diagramFormSchema = z.object({
  name: z.string().trim().min(1, 'validation.required').max(200, 'validation.tooLong'),
  description: z.string().max(10_000, 'validation.tooLong'),
});
export type DiagramFormValues = z.infer<typeof diagramFormSchema>;
